<template>
  <div class="d-flex flex-column gap-6">
    <basic-question
      v-model="modelValue.overallSituation"
      kind="radio"
      title="Como está sua asma hoje?"
      :questionData="{
        options: {
          'Muito ruim': 0,
          Ruim: 1,
          Bem: 2,
          'Muito bem': 3,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.blockedActivitiesRate"
      kind="radio"
      title="O quanto a sua asma atrapalha quando você corre, faz exercício físico ou pratica esportes?"
      :questionData="{
        options: {
          'Atrapalha muito, eu não posso fazer o que eu quero': 0,
          'Atrapalha um pouco e eu não gosto disso': 1,
          'Atrapalha só um pouquinho, mas eu nem ligo': 2,
          'Não atrapalha nada': 3,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.coughingRate"
      kind="radio"
      title="Você tosse por causa de sua asma?"
      :questionData="{
        options: {
          'Sim, o tempo todo': 0,
          'Sim, a maior parte do tempo': 1,
          'Sim, algumas vezes': 2,
          'Não, nunca': 3,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.nightAwakeningsRate"
      kind="radio"
      title="Você acorda durante a noite por causa de sua asma?"
      :questionData="{
        options: {
          'Sim, o tempo todo': 0,
          'Sim, a maior parte do tempo': 1,
          'Sim, algumas vezes': 2,
          'Não, nunca': 3,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.parentSymptomsRate"
      kind="radio"
      title="Durante as últimas 4 semanas, quantos dias a criança teve algum sintoma da asma durante o dia?"
      :questionData="{
        options: {
          Nenhum: 5,
          '1 a 3 dias': 4,
          '4 a 10 dias': 3,
          '11 a 18 dias': 2,
          '19 a 24 dias': 1,
          'Todos os dias': 0,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.parentWheezingRate"
      kind="radio"
      title="Durante as últimas 4 semanas, quantos dias a criança teve chiado no peito durante o dia por causa da asma?"
      :questionData="{
        options: {
          Nenhum: 5,
          '1 a 3 dias': 4,
          '4 a 10 dias': 3,
          '11 a 18 dias': 2,
          '19 a 24 dias': 1,
          'Todos os dias': 0,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.parentNightAwakeningsRate"
      kind="radio"
      title="Durante as últimas 4 semanas, quantos dias a criança acordou durante a noite por causa da asma?"
      :questionData="{
        options: {
          Nenhum: 5,
          '1 a 3 dias': 4,
          '4 a 10 dias': 3,
          '11 a 18 dias': 2,
          '19 a 24 dias': 1,
          'Todos os dias': 0,
        },
      }"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { PropOptions, WatchOptionsWithHandler } from 'vue'
import { isEmpty } from 'lodash'
import BasicQuestion from '@/components/NewAttendanceForm/Questions/Basic/BasicQuestion.vue'

/**
 * @typedef {Object} ModelValue
 * @property {number?} overallSituation
 * @property {number?} blockedActivitiesRate
 * @property {number?} coughingRate
 * @property {number?} nightAwakeningsRate
 * @property {number?} parentSymptomsRate
 * @property {number?} parentWheezingRate
 * @property {number?} parentNightAwakeningsRate
 */

export default {
  name: 'ACTChildQuestions',
  components: {
    BasicQuestion,
  },
  props: {
    /** @type {PropOptions<ModelValue>} */
    value: {
      type: Object,
    },
    /** @type {PropOptions<boolean>} */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    /** @type {ModelValue} */
    const initialValue = {
      overallSituation: null,
      blockedActivitiesRate: null,
      coughingRate: null,
      nightAwakeningsRate: null,
      parentSymptomsRate: null,
      parentWheezingRate: null,
      parentNightAwakeningsRate: null,
    }

    /** @type {ModelValue} */
    const modelValue = isEmpty(this.value) ? initialValue : { ...initialValue, ...cloneDeep(this.value) }

    return {
      modelValue,
    }
  },
  watch: {
    /** @type {WatchOptionsWithHandler<ModelValue>} */
    modelValue: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    },
  },
}
</script>

<style></style>
